<template>
    <div class="specifications" v-if="specificationsData.length > 0">
        <div class="title">Špecifikácie</div>
        <table>
            <tr v-for="specification in specificationsData" :key="specification.id">
                <th>{{ specification.name }}</th>
                <td>
                    {{ specification.pivot.value }}
                    <span v-if="specification.mu">
                        {{ specification.mu }}
                    </span>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
    export default {
        props: {
            specificationsData: {
                required: false,
                type: Array
            }
        },
    }
</script>
